import ajax from '@finance/ajax'
import useragent from '@common/useragent'
import '@common/sui-sdk'

let isCache = false
const storageWithTime = {
  set(key, value, hour = 6) {
    const obj = {
      value,
      currentTime: Date.now(),
      duration: hour
    }
    localStorage.setItem(key, JSON.stringify(obj))
  },
  get(key) {
    let obj = localStorage.getItem(key)
    const now = Date.now()
    let returnValue

    if (obj) {
      try {
        obj = JSON.parse(obj)
        if (now - obj.currentTime > obj.duration * 60 * 60 * 1000) {
          returnValue = undefined
          localStorage.removeItem(key)
        } else {
          returnValue = obj.value
        }
      } catch (e) {
        returnValue = obj
      }
    } else {
      returnValue = undefined
    }

    return returnValue
  }
}

function verify(result, success, error, count = 1) {
  let ended = false // config回调是否结束
  let skipped = false // 是否已跳过config回调
  if (count > 10) {
    error && error('鉴权验证在3s内不成功，直接执行错误处理')
    return
  }
  setTimeout(function() {
    if (!ended) {
      skipped = true
      verify(result, success, error, count + 1)
    }
  }, 300)
  window.sui.config({
    appId: result.corpId || result.corpid, // 必填，合作方的唯一标识
    timestamp: result.timestamp, // 必填，生成签名的时间戳
    nonceStr: result.nonceStr, // 必填，生成签名的随机串
    signature: result.signature, // 必填，签名
    success(res) {
      ended = true
      if (skipped) {
        return
      }
      console.log('verify auth success', res)
      success && success(res)
    },
    error(err) {
      ended = true
      if (skipped) {
        return
      }
      console.log('verify auth error', err)
      if (isCache) {
        // eslint-disable-next-line
        fetchSign(success, error)
      } else {
        error && error(err)
      }
    }
  })
}
function fetchSign(success, error) {
  const hostname = location.hostname
  const isProd = /^yunres\.feidee\.com|^marketres|^m\.feidee\.com|^operation\.feidee\.com/.test(hostname)
  const isUat = /^yunuatres|^lcuatres/.test(hostname)
  let api = 'https://api.feidee.cn/v1/js-sdk/sign'
  if (isProd || isUat) {
    api = 'https://api.feidee.net/v1/js-sdk/sign'
  }
  isCache = false
  ajax.request({
    url: `${api}?encode_url=${encodeURIComponent(location.hostname)}`,
    method: 'get'
  }).then((result) => {
    console.log(result)
    if (result) {
      storageWithTime.set('sui-sdk-sign', JSON.stringify(result), 23)
      verify(result, success, error)
    }
  }).catch((e) => {
    error(e)
  })
}

export default window.sui
export function verifyAuth(useCache = false) {
  if (useragent.isSuishouji || useragent.isKaniu) {
    return new Promise((resolve, reject) => {
      const sign = storageWithTime.get('sui-sdk-sign')
      if (useCache && sign) {
        try {
          const data = JSON.parse(sign)
          isCache = true
          verify(data, resolve, reject)
          // eslint-disable-next-line
        } catch (e) {}
      } else {
        fetchSign(resolve, reject)
      }
    })
  }

  return Promise.reject({ code: 9999, msg: '当前运行环境不是随手记或卡牛APP' })
}